<template>
<div>
  <v-dialog v-model="priceHistoryDialog" max-width="500px">
    <v-card>
      <v-card-title >
          <v-layout row wrap justify-center align-center color="grey lighten-3">
            <v-flex xs12>
              <h2>{{serialNumber}}</h2>
            </v-flex>
          </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12>
              <v-data-table
                v-bind:headers="headers"
                :items="items"
                hide-actions
              >
                <template v-slot:items="props">
                  <td>{{ props.item.created_on | formatDate }}</td>
                  <td v-for="item in props.item.list" :key="item.price">{{ item.price  | currency('$', 2)}}</td>
              </template>
              </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="closeDialog">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: undefined,
    },
    priceHistoryDialog: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: undefined,
    },
  },
  computed: {
    serialNumber() {
      return this.product ? this.product.serial_number : '';
    },
  },
  data() {
    return {
      headers: [
        { text: 'Fecha', value: 'created_on' },
        { text: 'Lista D', value: 'price_1' },
        { text: 'Lista C', value: 'price_2' },
        { text: 'Lista B', value: 'price_3' },
        { text: 'Lista A', value: 'price_4' },
      ],
    };
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog');
    },
  },
};
</script>
